class CashLimitCreator {
    constructor(cashLimit, realCreatorProvider) {
        this.cashLimit = cashLimit;
        this.realCreatorProvider = realCreatorProvider;
    }

    transform(t) {
        let result = t(`cash-limits.creators.${this.cashLimit.creator.toLowerCase().replace(/_/g, '-')}`);
        if (this.realCreatorProvider) {
            result += ` (${this.realCreatorProvider(this.cashLimit)})`;
        }
        return result;
    }
}

// eslint-disable-next-line import/prefer-default-export
export const getCashLimitCreator = (cashLimit) => {
    let result = null;
    switch (cashLimit.creator) {
        case 'CCP':
            result = new CashLimitCreator(cashLimit, (cl) => cl.ccp);
            break;
        case 'TSO':
            result = new CashLimitCreator(cashLimit, (cl) => cl.tso);
            break;
        case 'CLEARING_MEMBER':
            result = new CashLimitCreator(cashLimit, (cl) => cl.clearingMember);
            break;
        case 'SETTLEMENT_MEMBER':
            result = new CashLimitCreator(cashLimit, (cl) => cl.member.memberId);
            break;
        case 'OTHER':
            result = new CashLimitCreator(cashLimit);
            break;
        default:
            throw new Error(`Unknown cash limit creator: ${cashLimit.creator}`);
    }
    return result;
};

export const CCP_CREATOR_MAPPING_TMPL = new CashLimitCreator({ creator: 'CCP' }, () => 'ccp');
export const TSO_CREATOR_MAPPING_TMPL = new CashLimitCreator({ creator: 'TSO' }, () => 'tso');
export const CLEARING_MEMBER_CREATOR_MAPPING_TMPL = new CashLimitCreator({ creator: 'CLEARING_MEMBER' }, () => 'clearingMember');
export const SETTLEMENT_MEMBER_CREATOR_MAPPING_TMPL = new CashLimitCreator({ creator: 'SETTLEMENT_MEMBER' }, () => 'member.memberId');
export const OTHER_CREATOR_MAPPING_TMPL = new CashLimitCreator({ creator: 'OTHER' });

export const getAllCashLimitCreatorsForMapping = () => [
    CCP_CREATOR_MAPPING_TMPL,
    TSO_CREATOR_MAPPING_TMPL,
    CLEARING_MEMBER_CREATOR_MAPPING_TMPL,
    SETTLEMENT_MEMBER_CREATOR_MAPPING_TMPL,
    OTHER_CREATOR_MAPPING_TMPL,
];
